import React, {useState} from 'react'
import {State} from '../../../../../store/ducks'
import {connectComponent} from '../../../../../store/common'
import {ClientDTO, PushClientDTO} from 'grilnica-store-share'
import {NotificationListPageComponent} from './NotificationListPageComponent'

interface NotificationListPageProps {
  client: ClientDTO
  messages: PushClientDTO[]
}

const NotificationListPage: React.FC<NotificationListPageProps> = ({
  client,
  messages,
}): React.ReactElement => {
  const [isShowHidden, setIsShowHidden] = useState<boolean>(false)

  if (!!client) {
    return (
      <NotificationListPageComponent
        messages={messages}
        isShowHidden={isShowHidden}
        setIsShowHidden={setIsShowHidden}
      />
    )
  } else {
    return null
  }
}

export default connectComponent(
  (state: State) => ({
    client: state.auth.client,
    messages: state.push?.messages,
  }),
  () => ({}),
  NotificationListPage,
)
